import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KendoModule } from './kendo/kendo.module';
import { TranslateModule } from '@ngx-translate/core';
import { AutocompleteComponent } from './components/autocomplete/autocomplete.component';
import { FormGridComponent } from './components/form-grid/form-grid.component';
import { FormControlPipe } from './pipes/form-control.pipe';
import { AddressFormComponent } from './components/address-form/address-form.component';
import { FileInputComponent } from './components/file-input/file-input.component';
import { ReactiveFormsModule } from '@angular/forms';
import { DialogModule } from '@progress/kendo-angular-dialog';
import { HoverDirective } from './directives/hover.directive';
import { FileMultiselectComponent } from './components/file-select/file-select.component';
import { RichTextEditorComponent } from './components/rich-text-editor/rich-text-editor.component';

@NgModule({
  declarations: [FormControlPipe, HoverDirective, RichTextEditorComponent],
  imports: [
    CommonModule,
    FormGridComponent,
    KendoModule,
    TranslateModule,
    AddressFormComponent,
    AutocompleteComponent,
    FileInputComponent,
    ReactiveFormsModule,
    DialogModule,
    FileMultiselectComponent,
  ],
  exports: [
    KendoModule,
    CommonModule,
    FormControlPipe,
    TranslateModule,
    AutocompleteComponent,
    FormGridComponent,
    AddressFormComponent,
    FileInputComponent,
    HoverDirective,
    FileMultiselectComponent,
    RichTextEditorComponent
  ]
})
export class SharedModule {}
